export default {
  OPERACION_SEDE: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
